import { useEffect, useState } from 'react';

/**
 * 指定した時間後に入力値をデバウンスするカスタムフック
 * @returns {string} debouncedValue - 指定時間後のキーワード
 */
const useDebouncedKeyword = ({ value, delay = 500 }) => {
  const [debouncedValue, setDebouncedValue] = useState(value ?? '');

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
};

export default useDebouncedKeyword;
